import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { api, apiErrorMessage } from "@/lib/api";

const TREND_OPTIONS = [
  { value: "up", label: "Нагоре" },
  { value: "down", label: "Надолу" },
  { value: "flat", label: "Без промяна" },
];

export default function AdminHomepage() {
  const [articles, setArticles] = useState([]);
  const [leadId, setLeadId] = useState("");
  const [secondaryIds, setSecondaryIds] = useState([]);
  const [q, setQ] = useState("");
  const [ticker, setTicker] = useState([]);

  useEffect(() => {
    api.get("/admin/homepage-config").then(({ data }) => {
      setLeadId(data.lead_article_id || "");
      setSecondaryIds(data.secondary_article_ids || []);
    });
    api.get("/articles", { params: { status: "all", limit: 100 } }).then(({ data }) => setArticles(data.items));
    api.get("/market-ticker").then(({ data }) => setTicker(data));
  }, []);

  const toggleSecondary = (id) => {
    setSecondaryIds((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  };

  const save = async () => {
    try {
      await api.put("/admin/homepage-config", { lead_article_id: leadId || null, secondary_article_ids: secondaryIds });
      toast.success("Началната страница е обновена");
    } catch (err) {
      toast.error(apiErrorMessage(err));
    }
  };

  const updateTickerField = (slug, field, value) => {
    setTicker((prev) => prev.map((c) => (c.slug === slug ? { ...c, [field]: value } : c)));
  };

  const saveTicker = async () => {
    try {
      await api.put("/admin/market-ticker", { items: ticker.map((c) => ({ city: c.city, slug: c.slug, price_per_sqm: Number(c.price_per_sqm), trend: c.trend, order: c.order })) });
      toast.success("Метър сега е обновен");
    } catch (err) {
      toast.error(apiErrorMessage(err));
    }
  };

  const filtered = articles.filter((a) => a.title.toLowerCase().includes(q.toLowerCase()));

  return (
    <div data-testid="admin-homepage-page">
      <h1 className="font-serif text-3xl font-bold text-[#1A1A1A] mb-6">Начална страница</h1>
      <Input placeholder="Търси статия..." value={q} onChange={(e) => setQ(e.target.value)} className="mb-4 max-w-md" data-testid="admin-homepage-search-input" />
      <div className="bg-white border border-[#E2E8F0] divide-y divide-[#E2E8F0] max-h-[500px] overflow-y-auto mb-6" data-testid="admin-homepage-article-list">
        {filtered.map((a) => (
          <div key={a.id} className="flex items-center gap-4 px-4 py-3">
            <label className="flex items-center gap-2 text-sm">
              <input type="radio" name="lead" checked={leadId === a.id} onChange={() => setLeadId(a.id)} data-testid={`admin-homepage-lead-radio-${a.id}`} />
              Водеща
            </label>
            <label className="flex items-center gap-2 text-sm">
              <input type="checkbox" checked={secondaryIds.includes(a.id)} onChange={() => toggleSecondary(a.id)} data-testid={`admin-homepage-secondary-checkbox-${a.id}`} />
              Второстепенна
            </label>
            <span className="flex-1 text-sm text-[#1A1A1A]">{a.title}</span>
            <span className="text-xs text-[#718096]">{a.status}</span>
          </div>
        ))}
      </div>
      <Button onClick={save} className="bg-[#A6192E] hover:bg-[#8C1123]" data-testid="admin-homepage-save-btn">Запази</Button>

      <h2 className="font-serif text-2xl font-bold text-[#1A1A1A] mt-12 mb-4">Metri.bg Метър сега</h2>
      <p className="text-sm text-[#718096] mb-4">Средна цена на кв.м и посока на пазара (по обща преценка, не точна статистика) за 4 града.</p>
      <div className="bg-white border border-[#E2E8F0] divide-y divide-[#E2E8F0] mb-4" data-testid="admin-market-ticker-list">
        {ticker.map((c) => (
          <div key={c.slug} className="flex items-center gap-4 px-4 py-3">
            <span className="w-24 text-sm font-semibold text-[#1A1A1A]">{c.city}</span>
            <Input
              type="number"
              value={c.price_per_sqm}
              onChange={(e) => updateTickerField(c.slug, "price_per_sqm", e.target.value)}
              className="w-32"
              data-testid={`admin-ticker-price-${c.slug}`}
            />
            <span className="text-xs text-[#718096]">€/кв.м</span>
            <select
              value={c.trend}
              onChange={(e) => updateTickerField(c.slug, "trend", e.target.value)}
              className="border border-[#E2E8F0] text-sm px-2 py-1.5"
              data-testid={`admin-ticker-trend-${c.slug}`}
            >
              {TREND_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
            </select>
          </div>
        ))}
      </div>
      <Button onClick={saveTicker} className="bg-[#A6192E] hover:bg-[#8C1123]" data-testid="admin-market-ticker-save-btn">Запази Метър сега</Button>
    </div>
  );
}
